// Tabs
import {Tutorial, TutorialSection} from "@/data/classes/tutorial";
import router from "@/router";
import {getTutorials} from "@/data/api/tutorial";
let tutorialSection = new TutorialSection();

export const tabs : any[] = [
    {
        icon: "support",
        key: "general",
        title: "tutorial-section-form.title",
        type: "single",
        sections: [
            {
                inputs: [
                    {
                        label: 'tutorial-section-form.published',
                        name: 'input_tutorial_published',
                        type: 'select',
                        required: true,
                        path: "Published",
                        decode: (value: boolean) => {
                            return value?.toString();
                        },
                        encode: (value: string) => {
                            return value === "true";
                        },
                        options: [{
                            key: "true",
                            label: "tutorial-section-form.published-true",
                            value: "true"
                        },{
                            key: "false",
                            label: "tutorial-section-form.published-false",
                            value: "false"
                        }],
                        size: 50,
                    },
                    {
                        label: 'tutorial-section-form.type',
                        name: 'input_tutorial_type',
                        type: 'select',
                        required: true,
                        path: "Type",
                        disabled: false,
                        options: [{
                            key: "text",
                            label: "tutorial-section-form.type-text",
                            value: "text"
                        },{
                            key: "video",
                            label: "tutorial-section-form.type-video",
                            value: "video"
                        }],
                        size: 50
                    },
                    {
                        label: 'tutorial-section-form.outlining',
                        name: 'input_tutorial_outlining',
                        type: 'select',
                        required: true,
                        path: "Outlining",
                        options: [{
                            key: "left",
                            label: "tutorial-section-form.outlining-left",
                            value: "left"
                        },{
                            key: "right",
                            label: "tutorial-section-form.outlining-right",
                            value: "right"
                        }],
                        size: 50
                    }
                ]
            },
            {
                title: 'tutorial-section-form.content',
                inputs: [
                    {
                        label: 'tutorial-section-form.title',
                        name: 'input_tutorial_section_title',
                        type: 'text',
                        required: true,
                        path: "Title",
                        size: 80
                    },
                    {
                        label: 'tutorial-section-form.icon',
                        name: 'input_tutorial_section_icon',
                        type: 'text',
                        required: false,
                        path: "Icon",
                        size: 20
                    },
                    {
                        label: 'tutorial-section-form.text',
                        name: 'input_tutorial_section_text',
                        type: 'textarea',
                        required: false,
                        path: "Text",
                        size: 100,
                        condition: (item: TutorialSection) : boolean =>{
                            return item?.Type !== "video";
                        },
                        rootPath: "active"
                    },
                    {
                        label: "tutorial-form.image-header",
                        name: 'input_tutorial_image_header',
                        type: 'image',
                        required: false,
                        directUpload: true,
                        fileTypes: ["png", "jpg", "jpeg"],
                        maxFileSize: 50,
                        path: "ImageUrl",
                        folder: "tutorials/sections/",
                        saveName: "header",
                        urlPath: "ImageUrl",
                        extensionPath: "ImageExtension",
                        filenamePath: "ImageName",
                        widthPath: "ImageWidth",
                        heightPath: "ImageHeight",
                        sizePath: "ImageSize",
                        size: 50
                    }
                ]
            },
            {
                title: 'tutorial-section-form.button',
                inputs: [
                    {
                        label: 'tutorial-section-form.button-tutorial',
                        name: 'input_tutorial_section_button_tutorial',
                        type: 'select',
                        required: false,
                        dynamicOptions: async () => {
                            const {data} = await getTutorials({ language: tutorialSection.Language });
                            return data.map((tutorial: Tutorial) => {
                                return {
                                    key: tutorial.Id,
                                    value: tutorial.Id,
                                    label: tutorial.TitleShort
                                }
                            });
                        },
                        path: "ButtonLinkTutorialId",
                        size: 50
                    },
                    {
                        label: 'tutorial-section-form.button-text',
                        name: 'input_tutorial_section_button_text',
                        type: 'text',
                        required: false,
                        path: "ButtonText",
                        size: 50
                    }
                ]
            },
            {
                title: 'tutorial-section-form.sorting',
                inputs: [
                    {
                        label: 'tutorial-section-form.sort-index',
                        name: 'input_tutorial_sort_index',
                        type: 'number',
                        required: true,
                        path: "SortIndex",
                        size: 100
                    }
                ]
            },
            {
                title: 'tutorial-section-form.link',
                inputs: [
                    {
                        label: 'tutorial-section-form.link',
                        name: 'input_tutorial_link',
                        type: 'select',
                        required: false,
                        multiple: true,
                        sortOptions: false,
                        options: [
                            {
                                key: "element-audio",
                                label: "tutorial-section-form.help-links.element-audio",
                                value: "element-audio"
                            },
                            {
                                key: "element-button",
                                label: "tutorial-section-form.help-links.element-button",
                                value: "element-button"
                            },
                            {
                                key: "element-carousel",
                                label: "tutorial-section-form.help-links.element-carousel",
                                value: "element-carousel"
                            },
                            {
                                key: "element-contact",
                                label: "tutorial-section-form.help-links.element-contact",
                                value: "element-contact"
                            },
                            {
                                key: "element-custom-button",
                                label: "tutorial-section-form.help-links.element-custom-button",
                                value: "element-custom-button"
                            },
                            {
                                key: "element-event",
                                label: "tutorial-section-form.help-links.element-event",
                                value: "element-event"
                            },
                            {
                                key: "element-image",
                                label: "tutorial-section-form.help-links.element-image",
                                value: "element-image"
                            },
                            {
                                key: "element-object-3d",
                                label: "tutorial-section-form.help-links.element-object-3d",
                                value: "element-object-3d"
                            },
                            {
                                key: "element-vr-image",
                                label: "tutorial-section-form.help-links.element-vr-image",
                                value: "element-vr-image"
                            },
                            {
                                key: "element-vr-video",
                                label: "tutorial-section-form.help-links.element-vr-video",
                                value: "element-vr-video"
                            },
                            {
                                key: "element-video",
                                label: "tutorial-section-form.help-links.element-video",
                                value: "element-video"
                            },
                            {
                                key: "element-youtube",
                                label: "tutorial-section-form.help-links.element-youtube",
                                value: "element-youtube"
                            },
                            {
                                key: "marker-overview",
                                label: "tutorial-section-form.help-links.marker-overview",
                                value: "marker-overview"
                            },
                            {
                                key: "create-marker",
                                label: "tutorial-section-form.help-links.create-marker",
                                value: "create-marker"
                            },{
                                key: "test-marker",
                                label: "tutorial-section-form.help-links.test-marker",
                                value: "test-marker"
                            },{
                                key: "editor",
                                label: "tutorial-section-form.help-links.editor",
                                value: "editor"
                            },{
                                key: "add-customer",
                                label: "tutorial-section-form.help-links.add-customer",
                                value: "add-customer"
                            },{
                                key: "statistics",
                                label: "tutorial-section-form.help-links.statistics",
                                value: "statistics"
                            },{
                                key: "licenses",
                                label: "tutorial-section-form.help-links.licenses",
                                value: "licenses"
                            },{
                                key: "marker-statistics",
                                label: "tutorial-section-form.help-links.marker-statistics",
                                value: "marker-statistics"
                            },{
                                key: "customer-statistics",
                                label: "tutorial-section-form.help-links.customer-statistics",
                                value: "customer-statistics"
                            },{
                                key: "user-profile",
                                label: "tutorial-section-form.help-links.user-profile",
                                value: "user-profile"
                            },{
                                key: "library-page",
                                label: "tutorial-section-form.help-links.library-page",
                                value: "library-page"
                            },{
                                key: "library-modal",
                                label: "tutorial-section-form.help-links.library-modal",
                                value: "library-modal"
                            },{
                                key: "library-item-modal",
                                label: "tutorial-section-form.help-links.library-item-modal",
                                value: "library-item-modal"
                            },{
                                key: "bug-report",
                                label: "tutorial-section-form.help-links.bug-report",
                                value: "bug-report"
                            },{
                                key: "custom-button-action",
                                label: "tutorial-section-form.help-links.custom-button-action",
                                value: "custom-button-action"
                            },{
                                key: "button-action",
                                label: "tutorial-section-form.help-links.button-action",
                                value: "button-action"
                            },{
                                key: "carousel-action",
                                label: "tutorial-section-form.help-links.carousel-action",
                                value: "carousel-action"
                            },{
                                key: "audio-animation",
                                label: "tutorial-section-form.help-links.audio-animation",
                                value: "audio-animation"
                            },{
                                key: "button-animation",
                                label: "tutorial-section-form.help-links.button-animation",
                                value: "button-animation"
                            },{
                                key: "carousel-animation",
                                label: "tutorial-section-form.help-links.carousel-animation",
                                value: "carousel-animation"
                            },{
                                key: "contact-animation",
                                label: "tutorial-section-form.help-links.contact-animation",
                                value: "contact-animation"
                            },{
                                key: "custom-button-animation",
                                label: "tutorial-section-form.help-links.custom-button-animation",
                                value: "custom-button-animation"
                            },{
                                key: "event-animation",
                                label: "tutorial-section-form.help-links.event-animation",
                                value: "event-animation"
                            },{
                                key: "image-animation",
                                label: "tutorial-section-form.help-links.image-animation",
                                value: "image-animation"
                            },{
                                key: "object-3d-animation",
                                label: "tutorial-section-form.help-links.object-3d-animation",
                                value: "object-3d-animation"
                            },{
                                key: "video-animation",
                                label: "tutorial-section-form.help-links.video-animation",
                                value: "video-animation"
                            },{
                                key: "youtube-video-animation",
                                label: "tutorial-section-form.help-links.youtube-video-animation",
                                value: "youtube-video-animation"
                            },{
                                key: "object-3d-settings",
                                label: "tutorial-section-form.help-links.object-3d-settings",
                                value: "object-3d-settings"
                            },{
                                key: "video-settings",
                                label: "tutorial-section-form.help-links.video-settings",
                                value: "video-settings"
                            },{
                                key: "youtube-video-settings",
                                label: "tutorial-section-form.help-links.youtube-video-settings",
                                value: "youtube-video-settings"
                            },{
                                key: "custom-button-data",
                                label: "tutorial-section-form.help-links.custom-button-data",
                                value: "custom-button-data"
                            },{
                                key: "event-data",
                                label: "tutorial-section-form.help-links.event-data",
                                value: "event-data"
                            },{
                                key: "contact-style",
                                label: "tutorial-section-form.help-links.contact-style",
                                value: "contact-style"
                            },{
                                key: "custom-button-style",
                                label: "tutorial-section-form.help-links.custom-button-style",
                                value: "custom-button-style"
                            },{
                                key: "event-style",
                                label: "tutorial-section-form.help-links.event-style",
                                value: "event-style"
                            },{
                                key: "introduction",
                                label: "tutorial-section-form.help-links.introduction",
                                value: "introduction"
                            },{
                                key: "marker-rating",
                                label: "tutorial-section-form.help-links.marker-rating",
                                value: "marker-rating"
                            },{
                                key: "elements",
                                label: "tutorial-section-form.help-links.elements",
                                value: "elements"
                            },{
                                key: "customer-overview-empty",
                                label: "tutorial-section-form.help-links.customer-overview-empty",
                                value: "customer-overview-empty"
                            },{
                                key: "customer-overview",
                                label: "tutorial-section-form.help-links.customer-overview",
                                value: "customer-overview"
                            },{
                                key: "multi-language-creator",
                                label: "tutorial-section-form.help-links.multi-language-creator",
                                value: "multi-language-creator"
                            },{
                                key: "multi-language-editor",
                                label: "tutorial-section-form.help-links.multi-language-editor",
                                value: "multi-language-editor"
                            },{
                                key: "new-user",
                                label: "tutorial-section-form.help-links.new-user",
                                value: "new-user"
                            },{
                                key: "demo",
                                label: "tutorial-section-form.help-links.demo",
                                value: "demo"
                            }],
                        path: "Link",
                        size: 100
                    }
                ]
            },
            {
                title: 'tutorial-section-form.tags',
                inputs: [
                    {
                        label: 'tutorial-section-form.tags',
                        name: 'input_tutorial_section_tags',
                        type: 'array',
                        required: false,
                        path: "Tags",
                        size: 50
                    }
                ]
            },
        ]
    }
]


export const getData = async () => {
    if (router.currentRoute.params.tutorialSectionId !== "new"){
        await tutorialSection.get(router.currentRoute.params.tutorialSectionId, router.currentRoute.params.tutorialId);
    } else {
        tutorialSection = new TutorialSection();
    }

    return tutorialSection.toJSON();
}


export const onSubmit = async (formValues: any) => {
    // Set values
    tutorialSection.set(formValues);

    // Set tutorial ID
    tutorialSection.TutorialId = router.currentRoute.params.tutorialId;

    // Update license
    return tutorialSection.update();
}
